import { render } from "./BaseAutoComplete.vue?vue&type=template&id=679d8bf0&ts=true"
import script from "./BaseAutoComplete.vue?vue&type=script&lang=ts"
export * from "./BaseAutoComplete.vue?vue&type=script&lang=ts"

import exportComponent from "/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__